import React from 'react';
import {
    BrowserRouter as Router,
    Route, Routes,
    Navigate
} from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import HousePilot from './components/house/pilot/House_Pilot.js';
import HouseProg from './components/house/House_Prog.js';
import HouseVR from './components/house/House_VR.js';
import HouseElec from './components/house/House_Elec.js';
import HouseSauterPilot from './components/house-sauter/Pilot.js';
import HouseSauterProg from './components/house-sauter/Prog.js';
import HouseSauterElec from './components/house-sauter/Elec.js';

function RouterApp() {
    return (
        <>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    <Route path="/hs" element={<Navigate to="/hs/pilotage" replace />} />
                    <Route path="/hs/pilotage" element={<HouseSauterPilot />} />
                    <Route path="/hs/prog" element={<HouseSauterProg />} />
                    <Route path="/hs/elec" element={<HouseSauterElec />} />

                    <Route path="/house" element={<Navigate to="/house/pilotage" replace />} />
                    <Route path="/house/pilotage" element={<HousePilot />} />
                    <Route path="/house/prog" element={<HouseProg />} />
                    <Route path="/house/vr" element={<HouseVR />} />
                    <Route path="/house/elec" element={<HouseElec />} />
                    <Route path="/" element={<Home />} />

                    <Route path="*" element={<Navigate to="/" replace />} />

                </Routes>
            </Router>
        </>
    );
}

export default RouterApp;